// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'd9f46d84';
